/** Input component - reusable text input. */

import * as React from "react";
import { cn } from "../../utils";

/**
 * Input component props.
 */
export interface InputProps extends React.ComponentProps<"input"> {
  error?: string;
  label?: string;
}

/**
 * Input component - reusable text input.
 *
 * @param props - Input props
 * @returns Input componen
 */
const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, error, label, id, ...props }, ref) => {
  const input = (
    <input
      id={id}
      type={type}
      className={cn(
        ("surface-control flex h-9 w-full rounded-md border px-2.5 py-1.5 text-sm ring-offset-background transition-all duration-200 file:border-0 file:bg-transparent" +
          "file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-ring focus-visible:ring-2" +
          "focus-visible:ring-ring focus-visible:shadow-ring-glow disabled:cursor-not-allowed disabled:opacity-50"),
        error && "border-destructive focus-visible:border-destructive focus-visible:ring-destructive",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
  if (!label) return input;
  return (
    <label className="grid gap-1.5 text-sm font-medium text-foreground" htmlFor={id}>
      <span>{label}</span>
      {input}
    </label>
  );
});
Input.displayName = "Input";

export { Input };
